"use strict";
exports.__esModule = true;
require('../ability-to-launch/ability-to-launch.component.css');
var angular = require("angular");
var inav_utils_service_1 = require("../../../components/utils/inav-utils.service");
var issue_list_1 = require("../../../components/utils/issue-list/issue-list");
var AbilityToLaunchComponent = /** @class */ (function () {
    function AbilityToLaunchComponent($rootScope, $scope, $timeout) {
        this.stickyList = {};
        this.issueConfig = {};
        this.disableEdit = false;
        // This constructor is necessary for inject scope and timeout.
        var ctrl = this;
        ctrl.$scope = $scope;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(issue_list_1.IssueListEnum.DEFAULT);
        ctrl.options = { show: true, id: -1 };
        ctrl.$timeout = $timeout;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        $scope.$on('command:ABILITY_TO_LAUNCH', function (event, args) {
            ctrl.disableEdit = (args.node.permissions == 'r');
            $scope.$emit('workbench:loading', { 'load': false });
            ctrl.initComponent(event, args);
        });
        $timeout();
    }
    AbilityToLaunchComponent.prototype.onStickyChange = function (stickyIndex) {
        var ctrl = this;
        ctrl.updateChangeDate(stickyIndex);
        ctrl.saveDFV();
    };
    AbilityToLaunchComponent.prototype.radioExist = function (stickyData, key) {
        return stickyData.abilityToLaunch.key == key;
    };
    AbilityToLaunchComponent.prototype.onStChange = function (stickyData, key) {
        var ctrl = this;
        var calcImpactValues = ctrl.utilsService.calcImpactValues;
        stickyData.abilityToLaunch.key = stickyData.abilityToLaunch.key == key ? 'default' : key;
        if (stickyData.impactMappingList == 'default') {
            stickyData.calcImpact = calcImpactValues[stickyData.abilityToLaunch.key];
        }
        else {
            if (ctrl.radioOrCheckbox == 'radio') {
                stickyData.calcImpact = this.getCalculatedImpact(stickyData.impactMappingList[0]['display']);
            }
            else if (ctrl.radioOrCheckbox == 'checkbox') {
                stickyData.calcImpact = this.getCalculatedImpactCheckbox(stickyData.impactMappingList);
            }
            stickyData.calcImpact = calcImpactValues[stickyData.abilityToLaunch.key] > (stickyData.calcImpact || 0) ?
                calcImpactValues[stickyData.abilityToLaunch.key] : (stickyData.calcImpact || 0);
        }
        ctrl.saveDFV();
    };
    AbilityToLaunchComponent.prototype.getCalculatedImpactCheckbox = function (rangeArr) {
        var ctrl = this;
        var scores = [];
        rangeArr.forEach(function (range) {
            var npvSwing = ctrl.utilsService.getNpvSwing(range.display, ctrl.npvData);
            var npvMax = ctrl.npvData[0].npvSwing; // Considering first as max always
            var finalScore = Math.round((npvSwing / npvMax) * 8.99 + 0.5);
            scores.push(finalScore);
        });
        return rangeArr.length > 0 ? Math.max.apply(Math, scores) : null;
    };
    AbilityToLaunchComponent.prototype.getCalculatedImpact = function (display) {
        var ctrl = this;
        var npvSwing = ctrl.utilsService.getNpvSwing(display, ctrl.npvData);
        var npvMax = ctrl.npvData[0].npvSwing; // Considering first as max always
        return Math.round((npvSwing / npvMax) * 8.99 + 0.5);
    };
    AbilityToLaunchComponent.prototype.updateChangeDate = function (id) {
        var ctrl = this;
        ctrl.defaultSt[id].updatedAt = ctrl.utilsService.updatedAt();
    };
    AbilityToLaunchComponent.prototype.deleteSticky = function (issueId, list) {
        var ctrl = this;
        for (var i = 0; i < list.length; i++) {
            if (issueId == list[i]._id) {
                list.splice(i, 1);
                break;
            }
        }
        ctrl.saveDFV();
    };
    AbilityToLaunchComponent.prototype.setHoveredSticky = function (show, id) {
        var ctrl = this;
        ctrl.options = { show: true, id: id };
    };
    AbilityToLaunchComponent.prototype.showIcons = function (id) {
        var ctrl = this;
        return ctrl.options.show == true && ctrl.options.id == id;
    };
    AbilityToLaunchComponent.prototype.populateItemList = function (dfvType, data) {
        var ctrl = this;
        data.forEach(function (d) {
            if (d['isPotentialShowStopper']) {
                d['name'] = d.name ? d.name : d.title;
                d['type'] = dfvType;
                d['color'] = ctrl.issueConfig[dfvType];
                ctrl.defaultSt.push(d);
            }
        });
    };
    AbilityToLaunchComponent.prototype.initComponent = function (event, args) {
        var ctrl = this;
        ctrl.title = args.actionMenuItem;
        ctrl.nodeName = args.node.name;
        ctrl.node = args.node;
        ctrl.menu = [];
        ctrl.emptyAll();
        ctrl.radioOrCheckbox = args.config.data['radioOrCheckbox'];
        ctrl.npvData = args.config.data['npvSwingData'];
        ctrl.initCanvasData(args.config.data);
    };
    AbilityToLaunchComponent.prototype.emptyAll = function () {
        var ctrl = this;
        ctrl.easySt = [];
        ctrl.mediumSt = [];
        ctrl.hardSt = [];
        ctrl.defaultSt = [];
        ctrl.npvData = [];
        ctrl.radioOrCheckbox = '';
    };
    AbilityToLaunchComponent.prototype.initCanvasData = function (data) {
        var ctrl = this;
        ctrl.issueConfig = ctrl.utilsService.getIssueConfig(data['CanvasConfig']);
        ctrl.stickyList = data['NColCanvasSwotData'];
        // Iterate objects
        Object.keys(data['NColCanvasSwotData']).forEach(function (key) {
            ctrl.populateItemList(key, ctrl.stickyList[key]);
        });
    };
    AbilityToLaunchComponent.prototype.saveDFV = function () {
        var ctrl = this;
        // if (!ctrl.duplicateExists()) {
        var req = {};
        ctrl.defaultSt.forEach(function (x) {
            // init if array not exist
            if (!req[x.type])
                req[x.type] = [];
            req[x.type].push(x);
        });
        ctrl.$timeout(function () {
            ctrl.smartorg.saveAbilityToLaunchData(ctrl.node._id, req).then(function (res) {
                if (res) {
                    ctrl.$timeout();
                    ctrl.$scope.$apply();
                }
                else {
                    ctrl.showAlert('danger', 'Error!', res.message);
                }
            })["catch"](function (err) {
                ctrl.showAlert('danger', 'Error!', err.message);
            });
        }, 500);
        // }
    };
    return AbilityToLaunchComponent;
}());
exports.AbilityToLaunchComponent = AbilityToLaunchComponent;
angular.module('smartorg.r6.acts.abilityToLaunch', []).component('abilityToLaunch', {
    template: require('./ability-to-launch.component.html'),
    controller: AbilityToLaunchComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = 'smartorg.r6.acts.abilityToLaunch';
//# sourceMappingURL=ability-to-launch.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/ability-to-launch/ability-to-launch.component.js